module.exports = __webpack_public_path__ + "ic-insights-application.svg?2473353fabed2b28ab948486bd18da9a";